import React from 'react'
import { Typography, Grid, Avatar, makeStyles } from '@material-ui/core'
import imagePreview from '../../../assets/images/Profile.PNG'
const useStyles = makeStyles((theme) => ({
  fill: {
    width: '94%',
  },
  large: {
    marginTop: '10px',
    width: theme.spacing(15),
    height: theme.spacing(15),
  },
}))
function LeadView({ lead }) {
  const classes = useStyles()
  //console.log('LEAD QUOTE : ', lead.quoteNumber)
  const data = [
    { label: 'Name', data: lead && lead.customer.name },
    // { label: 'Source', data: 'Dummy' },
    { label: 'Designation', data: lead && lead.customer && lead.customer.designation },
    { label: 'Type', data: lead && lead.status && lead.status.name },
    { label: 'Email', data: lead && lead.customer && lead.customer.email },
    { label: 'Phone', data: lead && lead.customer && lead.customer.phoneNumber },
    { label: 'State', data: lead && lead.customer && lead.customer.state },
    { label: 'Pincode', data: lead && lead.customer && lead.customer.pincode },
    { label: 'Amount', data: lead.leadAmount },
    { label: 'GST Number', data: lead && lead.customer && lead.customer.gstNumber },
    //{ label: 'Message', data: lead && lead.customer && lead.customer.message },
    { label: 'Remarks', data: lead && lead.remarks },
    { label: 'Quote Number', data: lead && lead.quoteNumber },
  ]
  const data2 = [
    { label: 'Agent', data: lead && lead.addedBy && lead.addedBy.firstName },
    { label: 'State', data: lead && lead.addedBy && lead.addedBy.state && lead.addedBy.state.name },
    // { label: 'Address', data: 'Dummy' },
  ]

  return (
    <Grid container lg={12} style={{ margin: '0px 15px' }}>
      <Grid item lg={4} container style={{ borderL: '1px solid black' }}>
        <Grid item lg={12}>
          <Avatar src={lead && lead.customer && lead.customer.profilePicture} className={classes.large} />
        </Grid>
        {data2.map((item, index) => (
          <Grid item lg={12}>
            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }} key={item.label}>
              <Typography style={{ fontSize: '16px', fontWeight: 550 }}>{item.label}</Typography>
              <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
            </div>
          </Grid>
        ))}
      </Grid>
      <Grid item lg={8} container>
        {data.map((item, index) => (
          <Grid item lg={6}>
            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }} key={item.label}>
              <Typography style={{ fontSize: '16px', fontWeight: 550 }}>{item.label}</Typography>
              <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
            </div>
          </Grid>
        ))}
      </Grid>
      {/* <Grid item lg={12}>
        <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
          <Typography style={{ fontSize: '16px', fontWeight: 550 }}>Message</Typography>
          <Typography style={{ fontSize: '14px', fontWeight: 400 }}>----</Typography>
        </div>
      </Grid> */}
    </Grid>
  )
}

export default LeadView
